import { Box } from "@mui/material";
import ChecklistNavigation from "./ChecklistNavigation";
import EditOrderNumber from "./edit-components/EditOrderNumber";
import DeleteChecklist from "./DeleteChecklist";
import ChecklistData from "./ChecklistData";
import ChecklistComments from "./comments/ChecklistComments";
import { useAppSelector } from "app/hooks";
import { selectUserRole } from "features/auth/authSlice";
import ChecklistProductsSection from "./serials/ChecklistProductsSection";
import MediaSection from "./MediaSection";
import { UserRole } from "features/auth/types/user";
import ExcludeChecklist from "./edit-components/ExcludeChecklist";
import PageLayout from "components/PageLayout";
import Breadcrumbs from "features/breadcrumbs/Breadcrumbs";
import Tabs from "components/Tabs";
import OutlinedCard from "components/OutlinedCard";
import { useGetThumbnailsByIdsQuery } from "app/api/media";
import { useChecklistContext } from "context/ChecklistContext";

const ChecklistDetails: React.FC = () => {
  const { checklist, comments } = useChecklistContext();
  const { data: imageThumbUrls } = useGetThumbnailsByIdsQuery({
    thumbnailIds: checklist.verification.map((v) => v.id),
  });
  const userRole = useAppSelector(selectUserRole);

  const userCanEdit = userRole === UserRole.ADMIN || userRole === UserRole.USER_ADMIN;
  const userCanExclude =
    userRole === UserRole.ADMIN || userRole === UserRole.USER_ADMIN || userRole === UserRole.SALES;
  const userCanDelete = userRole === UserRole.ADMIN;

  const productsCount = checklist.installedProducts.length + checklist.serialEntities.length;

  if (!checklist) return null;

  return (
    <PageLayout>
      <Box display="grid" gridTemplateColumns="1fr auto 1fr" alignItems="center">
        <Breadcrumbs />

        <Box>{checklist.allChecklists.length > 1 && <ChecklistNavigation />}</Box>

        <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent="end">
          {userCanEdit && <EditOrderNumber />}
          {userCanExclude && <ExcludeChecklist checklist={checklist} />}
          {userCanDelete && <DeleteChecklist />}
        </Box>
      </Box>

      {checklist && <ChecklistData checklist={checklist} />}

      <OutlinedCard sx={{ p: 0 }}>
        <Tabs
          queryKey="section"
          values={[
            {
              key: "media",
              label: "Bilder & filmer",
              badgeCount: imageThumbUrls?.length,
              content: <MediaSection />,
            },
            {
              key: "comments",
              label: "Kommentarer",
              badgeCount: comments.length,
              content: <ChecklistComments />,
            },
            {
              key: "products",
              label: "Produkter",
              badgeCount: productsCount,
              content: <ChecklistProductsSection />,
            },
          ]}
        />
      </OutlinedCard>
    </PageLayout>
  );
};

export default ChecklistDetails;
